function hasValue(value) {
  return value !== null && value !== undefined && value !== "";
}

export function formatProductLabel(value) {
  const normalized = String(value || "")
    .trim()
    .replace(/[_-]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase();

  return normalized.replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function formatRepPrescription(display = {}) {
  if (display.repMode === "seconds") {
    return hasValue(display.targetSeconds) ? `${display.targetSeconds} sec` : null;
  }

  if (display.repMode === "repRange") {
    const hasMinimum = hasValue(display.minReps);
    const hasMaximum = hasValue(display.maxReps);

    if (hasMinimum && hasMaximum) {
      return display.minReps === display.maxReps
        ? `${display.minReps} reps`
        : `${display.minReps}-${display.maxReps} reps`;
    }
    if (hasMinimum) {
      return `At least ${display.minReps} reps`;
    }
    if (hasMaximum) {
      return `Up to ${display.maxReps} reps`;
    }
    return null;
  }

  return hasValue(display.targetReps) ? `${display.targetReps} reps` : null;
}

export function formatIntensity(intensity = {}) {
  if (!hasValue(intensity.value)) {
    return null;
  }

  if (intensity.mode === "rir") {
    return `RIR ${intensity.value}`;
  }
  if (intensity.mode === "rpe") {
    return `RPE ${intensity.value}`;
  }
  return null;
}

function hasIntensityMode(intensity) {
  return intensity?.mode === "rir" || intensity?.mode === "rpe";
}

export function resolveDisplayIntensity(setIntensity, exerciseIntensity, presentationFallback = null) {
  if (hasIntensityMode(setIntensity)) {
    return setIntensity;
  }
  if (hasIntensityMode(exerciseIntensity)) {
    return exerciseIntensity;
  }
  return hasIntensityMode(presentationFallback)
    ? presentationFallback
    : { mode: "none", value: null };
}

export function getExerciseMetadata(display = {}) {
  const focusLabels = Array.isArray(display.muscleFocusLabels)
    ? display.muscleFocusLabels.filter(Boolean).map(formatProductLabel)
    : [];
  const mechanic = display.mechanicType
    ? formatProductLabel(display.mechanicType)
    : null;

  return [...focusLabels, mechanic].filter(Boolean);
}

export function formatPercentage(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "0%";
  }
  const rounded = Math.round(numeric * 10) / 10;
  return `${rounded}%`;
}
